export * from './createColors';
export * from './createColorsFromMap';
export * from './rgbHex';
export * from './rgbaString';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/color-map/dist-es2015/index.js
// module id = 1876
// module chunks = 0